module.exports = __webpack_public_path__ + "static/media/earth.0252ef6b.svg";